import VenmoImg from '@assets/venmo_img.svg';
import ModalItem from './ModalItem';
import classes from '../index.module.css';

const venmoTipsMap = ['1. Sign in to your Venmo account', '2. Tap the menu icon in the top left corner', '3. Beside your profile picture, you’ll find your username'];

export default function Venmo({ fields }) {
  // const form = Form.useFormInstance();
  // const handleRadioChange = () => {
  //   form.setFieldsValue({ venmoEmail: undefined, phoneNumber: undefined });
  // };

  return (
    <>
      {fields.map((field) => <ModalItem field={field} key={field.value} />)}
      <div>
        <div className={classes.venmo_title}>How to find your Venmo username?</div>
        <ul className={classes.venmo_desc}>
          {venmoTipsMap.map((item) => <li key={item}>{item}</li>)}
        </ul>
      </div>
      <img src={VenmoImg} alt="" className={classes.venmo_img} />
    </>
  );
  // return (
  //   <Form.Item name="venmoType" noStyle style={{ width: '100%' }}>
  //     <Radio.Group onChange={handleRadioChange}>
  //       <Radio value={VENMO_TYPE_EMAIL}>
  //         <Form.Item
  //           name="venmoEmail"
  //           label="Email"
  //           style={{ width: '100%' }}
  //           rules={[
  //             {
  //               validator: async (_, value) => {
  //                 if (form.getFieldValue('venmoType') === VENMO_TYPE_EMAIL && !value) {
  //                   return Promise.reject(new Error('Email is required'));
  //                 }
  //                 if (form.getFieldValue('venmoType') === VENMO_TYPE_EMAIL && value && !isEmail(value)) {
  //                   return Promise.reject(new Error("That doesn't look like an email address"));
  //                 }
  //                 return Promise.resolve();
  //               },
  //             },
  //           ]}
  //         >
  //           <Input />
  //         </Form.Item>
  //       </Radio>

  //       <br />
  //       <Radio value={VENMO_TYPE_PHONE}>
  //         <Form.Item
  //           name="phoneNumber"
  //           label="U.S phone number"
  //           rules={[
  //             {
  //               validator: async (_, value) => {
  //                 if (form.getFieldValue('venmoType') === VENMO_TYPE_PHONE && !value) {
  //                   return Promise.reject(new Error('Please input your U.S phone number'));
  //                 }
  //                 if (form.getFieldValue('venmoType') === VENMO_TYPE_PHONE && value && !/^\d{10}$/.test(value)) {
  //                   return Promise.reject(new Error('Invalid U.S phone number'));
  //                 }
  //                 return Promise.resolve();
  //               },
  //             },
  //           ]}
  //         >
  //           <Input placeholder="(201)555-0123" prefix="+1" />
  //         </Form.Item>
  //       </Radio>
  //     </Radio.Group>
  //   </Form.Item>
  // );
}
